import React from "react";
var NoSearchResultMsg = function (props) {
    return (React.createElement("div", { className: "d-flex flex-column justify-content-center gap-2 mt-2" },
        React.createElement("span", { className: "justify-content-center d-flex" },
            React.createElement("i", { className: "edel-icon-wentwrong-search text-center" })),
        React.createElement("span", { className: "DMSan_14_500  txt_secondary-gray  text-center lineh-20" }, props === null || props === void 0 ? void 0 : props.message)));
};
export default NoSearchResultMsg;
